import React from "react";

function EnabledField({ value, onChange }) {

    const handleCheckboxChange = async (value) => {
        onChange(value);
    };

    return (
        <div className="oct_syslog-checkbox-v2">
            <input type="checkbox"
                id="syslogEnabled"
                checked={value}
                //disabled={disabled}
                onChange={() => handleCheckboxChange(!+value)} />
            <label htmlFor="syslogEnabled">Syslog Client Enabled</label>
        </div>
    )

}


export default EnabledField;
